import { merge } from '@bingads-webui-universal/primitive-utilities';

export const getStyles = styleOverrides => () => merge({
  TextAssetContainer: {
    marginBottom: '5px',

    '&:not(:first-child)': {
      marginTop: '16px',
    },

    '& .remaining-hint': {
      marginBottom: '5px',
    },
  },

  labelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  WithFlexButtons: {
    display: 'flex',

    '& .text-asset-copilot > button': {
      height: '30px',

      '&:first-of-type': {
        marginLeft: '8px',
      },
    },

    '& > button': {
      height: '30px',
    },
  },

  TextAssetsCollectionContainer: {
    width: '552px',
    '& div .error': {
      color: '#A80000',
    },
  },

  AddAssetButton: {
    marginBottom: '15px',
  },
}, styleOverrides);
